import { UIViewEnum } from "../../common/enums/UIViewEnum";
import useTabs from "../../hooks/use-tabs/useTabs";
import { routesByViewID } from "../../routes/routes";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { TabEnum } from "./SummaryListingViewUtils";
import SummaryListingViewContentBody from "./SummaryListingViewContentBody";



export type SummaryListingViewContentProps = {
    groupID: number,
    contextObject: IeLynxObject,
    configurationID: number | undefined,
}


export default function SummaryListingViewContent({
    groupID,
    contextObject, 
    configurationID,
}: SummaryListingViewContentProps) {

    const summaryListingTabs = [
        { key: TabEnum.Devices, route: routesByViewID.get(UIViewEnum.Group_SummaryListing_Devices) },
        { key: TabEnum.Wells, route: routesByViewID.get(UIViewEnum.Group_SummaryListing_Wells) },
        { key: TabEnum.TankBatteries, route: routesByViewID.get(UIViewEnum.Group_SummaryListing_TankBatteries) },
        { key: TabEnum.AlarmLynx, route: routesByViewID.get(UIViewEnum.Group_SummaryListing_AlarmLynx) },
        { key: TabEnum.CompressorLynx, route: routesByViewID.get(UIViewEnum.Group_SummaryListing_CompressorLynx) },
    ];

    const [activeTab, setActiveTab] = useTabs<TabEnum>("SummaryListing", summaryListingTabs, TabEnum.None);

    return (
        <SummaryListingViewContentBody
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            groupID={groupID}
            contextObject={contextObject}
            configurationID={configurationID}
        />
    );
}
